import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  SidebarMenuContainer,
  LogoContainer,
  NavbarContainer,
  LogoContainerr,
  StyledNavLink,
  NavItem,
  IconDesktopContainer,
} from "./index.styled";
import logoImg from "assets/icons/sidebarMenu/logo.png";

export default function SidebarMenu({
  logo,
  title,
  navItems,
  align = "right",
  activatedId,
}) {
  const location = useLocation();
  const [activePath, setActivePath] = useState(
    location.pathname.replaceAll("/", "")
  );

  useEffect(() => {
    setActivePath(location.pathname.replaceAll("/", ""));
  }, []);

  return (
    <SidebarMenuContainer align={align}>
      <LogoContainer>
        <LogoContainerr color="#89BEFF">
          <h2>آواشو</h2>
          <img src={logoImg} alt="logo" />
        </LogoContainerr>
      </LogoContainer>
      <NavbarContainer>
        <nav>
          <ul>
            {navItems.map((item) => (
              <StyledNavLink key={item.id} to={`/${item.path}`} color="#27548C">
                <li>
                  <NavItem color="#27548C">
                    <IconDesktopContainer>{item.icon}</IconDesktopContainer>
                    <p>{item.title}</p>
                  </NavItem>
                </li>
              </StyledNavLink>
            ))}
          </ul>
        </nav>
      </NavbarContainer>
    </SidebarMenuContainer>
  );
}
